import React, { Suspense } from 'react';
import styled from 'styled-components';

import ErrorBoundary from '../components/ErrorBoundary';
import { COMPONENT_MAPPING } from './components';
import { type IComponentSchema } from './types';
import { type IModelSummary } from '../types/model';

interface IProps {
  schema: IComponentSchema<any>;
  screenable?: IModelSummary;
  parentContext?: Record<string, any>;
}

const ComponentRenderer: React.FC<IProps> = ({
  schema,
  screenable,
  parentContext,
  ...rest
}) => {
  const Component =
    COMPONENT_MAPPING[schema['x-component'] as keyof typeof COMPONENT_MAPPING];

  if (!Component) {
    return (
      <StyledInfo>Component not found: {schema['x-component']}</StyledInfo>
    );
  }

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        fallback={
          <StyledError>
            Error rendering component: {schema['x-component']}
          </StyledError>
        }
      >
        <Component
          schema={schema}
          screenable={screenable}
          parentContext={parentContext}
          {...rest}
        />
      </ErrorBoundary>
    </Suspense>
  );
};

const StyledError = styled.div`
  display: flex;
  justify-content: center;
  background: ${props => props.theme.colors.errorLight};
  padding: ${({ theme }) => theme.spacing.sm};
`;

const StyledInfo = styled.div`
  display: flex;
  justify-content: center;
  background: ${props => props.theme.colors.infoLight};
  padding: ${({ theme }) => theme.spacing.sm};
`;

export default ComponentRenderer;
